import { useAppSelector } from "hooks/redux";
import { useState, useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import CoursesPage from "./routes/courses";

import SubjectsPage from "./routes/subjects";
import { SubjectCreate } from "./routes/subjects/create";
import { SubjectUpdate } from "./routes/subjects/update";
import ChaptersPage from "./routes/chapter";
import { ChapterUpdate } from "./routes/chapter/update";
import { ChapterCreate } from "./routes/chapter/create";
import { TopicCreate } from "./routes/topic/create";
import { TopicUpdate } from "./routes/topic/update";
import TopicPage from "./routes/topic";
import { CreateCourse } from "./routes/courses/create";
import { UpdateCourse } from "./routes/courses/update";

import CourseClassSubChapTopMap from "./routes/course-class-sub-chap-topi-map";
import { CourseClassSubChapTopMapCreate } from "./routes/course-class-sub-chap-topi-map/create";
import {CourseClassSubChapMapCreate} from "./routes/course-class-sub-chap-map/create";
import CourseClassSubChapMap from "./routes/course-class-sub-chap-map";

export interface IMatch {
  url: string;
}

export function GlobalContentPage({ match }: { match: IMatch }) {
  const { profileData } = useAppSelector((state) => state.gmailLoginReducer);
  const userRoleStr = profileData?.role;
  const userRole = userRoleStr?.split(",");

  const [showLoading, setShowLoading] = useState(true);

  useEffect(() => {
    // simulate async metadata or role check if needed
    setShowLoading(false);
  }, []);

  if (showLoading) return <p>Loading...</p>;

  return (
    <Switch>
      <Route
        exact
        path={`${match.url}/courses`}
        component={CoursesPage}
      />
      <Route
        exact
        path={`${match.url}/courses/create`}
        component={CreateCourse}
      />
      <Route
        exact
        path={`${match.url}/courses/edit`}
        component={UpdateCourse}
      />
      <Route
        exact
        path={`${match.url}/subjects`}
        component={SubjectsPage}
      />
      <Route
        exact
        path={`${match.url}/subjects/create`}
        component={SubjectCreate}
      />
      <Route
        exact
        path={`${match.url}/subjects/update`}
        component={SubjectUpdate}
      />
      <Route
        exact
        path={`${match.url}/chapter`}
        component={ChaptersPage}
      />
      <Route
        exact
        path={`${match.url}/chapter/create`}
        component={ChapterCreate}
      />
      <Route
        exact
        path={`${match.url}/chapter/update`}
        component={ChapterUpdate}
      />
      <Route
        exact
        path={`${match.url}/topic`}
        component={TopicPage}
      />
      <Route
        exact
        path={`${match.url}/topic/create`}
        component={TopicCreate
        }
      />
      <Route
        exact
        path={`${match.url}/topic/update`}
        component={TopicUpdate}
      />
       <Route
        exact
        path={`${match.url}/course_class_sub_chap_map`}
        component={CourseClassSubChapMap}
      />
       <Route
        exact
        path={`${match.url}/course_class_sub_chap_map/create`}
        component={CourseClassSubChapMapCreate}
      />
       <Route
        exact
        path={`${match.url}/course_class_sub_chap_top_map`}
        component={CourseClassSubChapTopMap}
      />
       <Route
        exact
        path={`${match.url}/course_class_sub_chap_top_map/create`}
        component={CourseClassSubChapTopMapCreate}
      />
      
    </Switch>
  );
}
